export const progressRingWrapperDivStyle = {
  minHeight: '200px',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const progressRingStyle = {
  margin: 'auto',
};
